import React, { Component } from 'react';
import '../styles/alignment.scss';
import { Field, Flag } from './index';
import Assets from 'src/requests/apa/Asset';
import { Match } from 'src/mundial/requests/interfaces';

interface IAlignmentProps {
    location: string;
}

export default class Alignment extends Component<IAlignmentProps> {
    location: string;
    state: any;
    constructor(props: IAlignmentProps) {
        super(props);
        this.location = props.location;
        this.state = { homeTeam: { flag: '', name: '' }, awayTeam: { flag: '', name: '' } };
    }

    componentDidMount() {
        const dataMatch: Match = JSON.parse(localStorage.getItem('match') || '{}');
        const { homeTeam, awayTeam } = dataMatch;
        this.setState({ homeTeam, awayTeam });
    }

    render() {
        const { homeTeam, awayTeam } = this.state;
        return (
            <div id="alignment">
                <div id="alignmentFlagLocal">
                    <div className="alignmentFlag">
                        <Flag size="small" imageFlag={homeTeam.flag} />
                        <div className="alignmentFlagName">{homeTeam.name}</div>
                    </div>
                </div>
                <div id="alignmentFlagVisit">
                    <div className="alignmentFlag">
                        <Flag size="small" imageFlag={awayTeam.flag} />
                        <div className="alignmentFlagName">{awayTeam.name}</div>
                    </div>
                </div>
                <div
                    id="alignmentField"
                    style={{
                        backgroundImage: `url(${Assets.get('match_lineup_soccerField_img')})`,
                    }}
                >
                    <Field location={this.location} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/Alignment.tsx